module.exports = __webpack_public_path__ + "pt.svg?03f36e39e92b313128a702a06fe14396";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/pt.svg
// module id = 1321
// module chunks = 0